module.exports = __webpack_public_path__ + "img/team-map-01.0d835535.png";